import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.gradePerQuestionTable.title',
    defaultMessage: 'Grade by Question',
  },
  export: {
    id: 'reports.gradePerQuestionTable.export',
    defaultMessage: 'Export Spreadsheet',
  },
  name: {
    id: 'reports.gradePerQuestionTable.name',
    defaultMessage: 'Name',
  },
  class: {
    id: 'reports.gradePerQuestionTable.class',
    defaultMessage: 'Class',
  },
  number: {
    id: 'reports.gradePerQuestionTable.number',
    defaultMessage: 'Registration',
  },
  timeStart: {
    id: 'reports.gradePerQuestionTable.timeStart',
    defaultMessage: 'Time Start',
  },
  timeFinish: {
    id: 'reports.gradePerQuestionTable.timeFinish',
    defaultMessage: 'Time Finish',
  },
  timeTaken: {
    id: 'reports.gradePerQuestionTable.timeTaken',
    defaultMessage: 'Time Taken',
  },
  hits: {
    id: 'reports.gradePerQuestionTable.hits',
    defaultMessage: 'ACCESS',
  },
  lp: {
    id: 'reports.gradePerQuestionTable.lp',
    defaultMessage: 'LP',
  },
  ge: {
    id: 'reports.gradePerQuestionTable.ge',
    defaultMessage: 'GE',
  },
  hi: {
    id: 'reports.gradePerQuestionTable.hi',
    defaultMessage: 'HI',
  },
  filename: {
    id: 'reports.gradePerQuestionTable.filename',
    defaultMessage: 'spreadsheet',
  },
});
